/**
 * Youtube player setup - load script and add event listeners
 *
 */

/**
 * When a player is ready start playing the video
 *
 * See player API docs:
 * https://developers.google.com/youtube/iframe_api_reference
 *
 * @param {event} event
 *
 */
window.onYoutubePlayerReady = function(event) {
  event.target.playVideo();

  const videoData = event.target.getVideoData();
  const youtubeId = videoData.video_id;
  window.playerManager.removeItem(youtubeId);
};

/**
 * Create a youtube player object
 *
 * @param {*} playerContainer
 * @param {*} youtubeId
 */
const createPlayer = (playerContainer, youtubeId) => {
  window[playerContainer] = new YT.Player(playerContainer, {
    height: '450',
    width: '800',
    videoId: youtubeId,
    host: 'https://www.youtube-nocookie.com',
    events: {
      'onReady': onYoutubePlayerReady,
    },
    playerVars: {
      'rel': 0,
    },
  });
};

/**
 * Returns the modal template
 *
 * @return {String}
 */
const getModalTemplate = () => {
  return `
  <div class="modal modal-youtube fade" id="youtubeModal" tabindex="-1"
    role="dialog">
    <div class="modal-youtube-inner">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button id="close-youtube-player" type="button" class="close"
              data-dismiss="modal" aria-label="Close">CLOSE</button>
          <div class="modal-body modal-body-youtube">
            <div class="embed-responsive embed-responsive-16by9">
              <div id="ytIframePlayer" class="embed-responsive-item"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;
};

const getLoader = (id) => {
  return `
    <div class="loader-container" data-loader-id="${ id }">
      <div="" class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>`;
};

/**
 * Handles modal youtube instances
 *
 * @param {String} id
 */
const handleModal = function(id) {
  const hasModal = document.querySelector('#youtubeModal');

  if (hasModal === null) {
    document.body.insertAdjacentHTML(
        'beforeend', getModalTemplate());
  }

  const playerContainer = 'ytIframePlayer';
  createPlayer(playerContainer, id);

  // Have to use jQuery here to interact with bootstrap modals
  $('#youtubeModal').modal();

  // When the modal is hidden then destroy the player
  $('#youtubeModal').on('hidden.bs.modal', function() {
    window['ytIframePlayer'].destroy();
    window.playerManager.removeLoaders();
  });
};

/**
 * Handle the inline player
 *
 * @param {HTMLElement} el
 * @param {String} id
 */
const handleInline = function(el, id) {
  const img = el.querySelector('img');
  el.classList.add('hide-footer');
  const playerContainer = img.id;
  createPlayer(playerContainer, id);
};

/**
 * Check to see if it's the modal version
 *
 * @param {HTMLElement} el
 * @return {Boolean}
 */
const isModalVersion = function(el) {
  return !!el.getAttribute('data-youtube-modal') &&
  el.getAttribute('data-youtube-modal') === 'true';
};

/**
 * Trigger the player
 *
 * @param {HTMLElement} el
 */
const play = function(el) {
  const id = el.getAttribute('data-youtube-id');
  if (isModalVersion(el)) {
    handleModal(id);
  } else {
    handleInline(el, id);
  }
};

// need to decide whether it's a play in place or a modal
const handleClick = (el) => {
  el.addEventListener('click', (event) => {
    event.preventDefault();
    play(el);
  });
};

const showLoader = function(el) {
  const youtubeId = el.getAttribute('data-youtube-id');

  if (isModalVersion(el)) {
    el.insertAdjacentHTML('beforeend', getLoader(youtubeId));
  } else {
    if (!el.querySelector('iframe')) {
      el.querySelector('.embed-responsive')
          .insertAdjacentHTML('beforeend', getLoader(youtubeId));
    }
  }
};

/**
 * Default function to configure component
 *
 * Add event listener for click that will load the API and
 * then play the video once it is loaded unregister the listener
 * and then add the click to play Listener
 *
 * @param {string} selector
 */
export default function(selector = '[data-youtube-id]') {
  // set up the playerManager object before anything else
  window.playerManager = (function() {
    let queue = [];
    return {
      hasQueue: () => !!queue.length,
      getQueue: () => queue,
      getLast: () => queue[queue.length - 1],
      addToQueue: (el) => queue.push(el),
      clearQueue: () => queue = [],
      removeItem: (id) => {
        queue = queue.filter((el) => {
          return id !== el.getAttribute('data-youtube-id');
        });

        // if we're still showing a loader then remove it
        const loader = document.querySelector('[data-loader-id="' + id + '"');

        if (loader) {
          loader.remove();
        }
      },
      removeLoaders: () => {
        queue.forEach( (el) => {
          // if (el.getAttribute('data-youtube-modal')) {
          const loaderElement = el.querySelector('.loader-container');
          if (loaderElement) {
            loaderElement.remove();
          }
          // }
        });
      },
    };
  })();

  const els = document.querySelectorAll(selector);
  // setup click listener to load and play on first interaction
  els.forEach((el) => {
    el.addEventListener('click', function(event) {
      event.preventDefault();
      window.playerManager.addToQueue(el);
      showLoader(el);
      loadScript();
    });
  });

  /**
   * Function to load the API script, set up to only
   * load the script once.
   */
  const loadScript = (function() {
    let scriptRequested = false;

    return () => {
      // check script hasn't already been requested
      if (scriptRequested === false ) {
        const tag = document.createElement('script');
        tag.id = 'youtube-iframe-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        scriptRequested = true;
      }
    };
  })();

  /**
   * Youtube API triggers this function when the
   * it is loaded and ready, we set the activePlayer
   * element in the initial click event handler
   * so that we can store the element if the API
   * isn't loaded.
   */
  window.onYouTubeIframeAPIReady = function() {
    if (window.playerManager.hasQueue()) {
      const els = window.playerManager.getQueue();

      els.forEach( (el) => {
        play(el);
      });

      // play(window.playerManager.getLast());
    }

    // Add the new click event listener
    if (typeof els !== 'undefined') {
      els.forEach((el) => {
        handleClick(el);
      });
    }
  };
}
